/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { ScenarioVideo } from './scenarioVideo'
import type { ScenarioVideoWithUrlAllOf } from './scenarioVideoWithUrlAllOf'

export type ScenarioVideoWithUrl = ScenarioVideo & ScenarioVideoWithUrlAllOf
